import {EpicGamesNav, EpicGamesNavProps, initBowser} from 'epic-games-nav/dist/client';
import addObserverCallback from 'epic-games-nav/dist/observe/epicGamesNavObserver';
import React from 'react';
import ReactDOM from 'react-dom';
import root from 'window-or-global';
import {
  EmbeddedNavLinkComponent,
  EmbeddedProvider,
} from 'epic-fortnite-react/components/mainNav/EmbeddedNavLinkComponent';
import {extractPath} from './utils/pathname.utils';

// renderNav is only used for the standalone header
const renderNav = () => {
  let config: EpicGamesNavProps = {};
  if (root._epicGamesNavObserver && root._epicGamesNavObserver.subject) {
    config = root._epicGamesNavObserver.subject;
  }
  initBowser();

  const theme = root._epicGamesNavTheme;

  const mobileOrTablet = root._epicGamesNav.browser.mobile || root._epicGamesNav.browser.tablet;

  if (config.callToActionDropdown && !mobileOrTablet) {
    config.callToActionDropdown.disabled = true;
  }

  // as we do not rely on the router handling the appContext we have to
  // add this to the links when it's present
  const pathname = (root.appContext ?? '') + extractPath(root.location.pathname);
  const serverURL = new URL(config.serverUrl);

  ReactDOM.render(
    <EmbeddedProvider serverURL={serverURL}>
      <EpicGamesNav
        theme={theme}
        {...config}
        pathname={pathname}
        LinkComponent={EmbeddedNavLinkComponent}
      />
    </EmbeddedProvider>,
    root.document.getElementById('epicGamesNavigation')
  );
};

addObserverCallback(renderNav);
renderNav();
